/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Careers_Whywedo_Thrill2Inputs */

const ja_careers_whywedo_thrill2 = /** @type {(inputs: Careers_Whywedo_Thrill2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`競技のスリル`)
};

const en_careers_whywedo_thrill2 = /** @type {(inputs: Careers_Whywedo_Thrill2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The thrill of competition!`)
};

/**
* | output |
* | --- |
* | "The thrill of competition!" |
*
* @param {Careers_Whywedo_Thrill2Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const careers_whywedo_thrill2 = /** @type {((inputs?: Careers_Whywedo_Thrill2Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Careers_Whywedo_Thrill2Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_careers_whywedo_thrill2(inputs)
	return en_careers_whywedo_thrill2(inputs)
});
export { careers_whywedo_thrill2 as "careers_whyWeDo_thrill" }